import React from "react";
import { Helmet } from "react-helmet";
import Ctapage from "../../Components/internal-pages/Cta_Section";
import LeftContentRightImg from "../../Components/sub-pages/Left-content-right-image";
import { Container } from "react-bootstrap";
import NogapleftImg from "../../Components/sub-pages/NogapleftImg";

const ExperientialGifitng =()=>{

    const CTAContent = [
        {
          pageName: "Experiential Gifting",
          paragraphitalic: "Go Beyond the Gift",
          paragraphText:
            "Turn gifting into an experience with custom gifting that evoke emotions and strengthen brand connections. Perfect for influencers, tastemakers, and premium client engagement.",
          ContactFormName: "Experiential Gifting",
        },
      ];
    
      const SubpgesLeftContent = [
        {
          index: 0,
          sectionName: "The Art of Gifting Experiences",
          parapgraphItalic: "Create unforgettable moments with gifts that go beyond the ordinary.",
          sectionparagraphText: (
            <>
              <p>
                Transform your gifting approach with experiences that leave a lasting impact. Whether it’s a luxury getaway, a relaxing spa retreat, or exclusive event access, our experiential gifting solutions are designed to create cherished memories. From corporate incentives to personalized surprises, we curate experiences that align with your brand and your recipients’ preferences.
              </p>
            </>
          ),
          ImgSrc: "../assests/images/experiential gifting/Custom Gifting.jpg",
        },
        /**Catagory Img */
        {
          index: 1,
          sectionName: "Stand Out with Thoughtful Experiences",
          parapgraphItalic: "",
          sectionparagraphText: (
            <>
              <p>
                Why gift objects when you can gift emotions? At eYantra, we specialize in curating experiences that resonate. From thrilling adventures to relaxing getaways, our experiential gifts ensure your brand is associated with joy, excitement, and appreciation.
              </p>
            </>
          ),
          ImgSrc: "../assests/images/experiential gifting/Innovative Designs.jpg",
          categoryHeadingLeftSide: "What we create?",
          CategoriesLeftContent: [
            {
              CategoryImg: "../assests/images/experiential gifting/Creative Concepts.png",
              CategoryName: (
                <>
                  <p className="fs-14">
                    <b>Tailored Experiences </b> <br></br>
                  </p>
                </>
              ),
            },
            {
              CategoryImg: "../assests/images/experiential gifting/Brand-Aligned Aesthetics.png",
              CategoryName: <>
              <p className="fs-14">
                <b>Memorable & Impactful </b> <br></br>
              </p>
            </>,
            },
            {
              CategoryImg: "../assests/images/experiential gifting/Trendy and Timeless.png",
              CategoryName: <>
              <p className="fs-14">
                <b>Trendsetting Concepts </b> <br></br>
              </p>
              </>,
            },
          ],
        },
      ];
      const noGapContent = [
        {
          RightImgNogap: "../assests/images/experiential gifting/What we create.jpg",
          NogapHeading: "What We Offer?",
          Heading: [
            {
              ListHeading: "Exclusive Experiences ",
              ListParagraph: "Gift travel vouchers, spa retreats, gourmet dining, and adventure getaways.",
            },
            {
              ListHeading: "Personalized Touch",
              ListParagraph: "Customize experiences with branded gift cards or tailored event access.",
            },
            {
              ListHeading: "Premium Selections",
              ListParagraph: "Choose from handpicked, high-quality experience packages.",
            },
          ],
        },
          {
            RightImgNogap: "../assests/images/experiential gifting/Seamless Delivery.jpg",
            NogapHeading: "Seamless Execution",
            paragraphItalic:"From selection to redemption, we handle it all.",
            paragraphDetail:(
              <>
                <p>
                  Imagine a gifting solution where every step is managed effortlessly—from choosing the perfect experience to ensuring a smooth redemption process. At eYantra, we take care of everything, offering end-to-end experiential gifting services that deliver joy without the hassle.
                </p>
              </>
            ),
            
            NogapSubheading:"What we offer?",
            Categories: [
              {
                ServiceImg: "../assests/images/experiential gifting/End-to-End Service.png",
                ServiceText: (
                  <>
                    <p className="fs-14">
                      <b>Hassle-Free Service </b> 
                    </p>
                  </>
                ),
              },
              {
                ServiceImg: "../assests/images/experiential gifting/Quality Assurance.png",
                ServiceText: (
                  <>
                    <p className="fs-14">
                      <b>Quality Guaranteed</b> 
                    </p>
                  </>
                ),
              },
              {
                ServiceImg: "../assests/images/experiential gifting/Timely Delivery.png",
                ServiceText: (
                  <>
                    <p className="fs-14">
                      <b>Timely Access </b>
                    </p>
                  </>
                ),
              },
            ],
            
        
        },
    
        /**new index */
        {
          RightImgNogap: "../assests/images/sub-pages/IMG-5.png",
          NogapHeading: "Milestone Recognition ",
          paragraphItalic: "Make sure every gift reflects excellence.",
          paragraphDetail: (
            <>
              <p>
              Appreciate dedication and achievements. 
              </p>
              <p>
                Show appreciation for the hard work and dedication that goes into every achievement. 
              </p>
              <p>
              Milestones such as work anniversaries, project completions, and promotions deserve to be celebrated. At eYantra, we provide a range of premium milestone gifts that are as unique as the achievements. 
              </p>
            </>
          ),
    
          NogapSubheading: "Our Milestone Gift Options Include:",
          Categories: [
            {
              ServiceImg: "../assests/images/sub-pages/logo-printing.png",
              ServiceText: (
                <>
                     
                    <p className="fs-14">
                    <b>Personalized Awards</b>
                  </p>
                </>
              ),
            },
            {
              ServiceImg: "../assests/images/sub-pages/engraving.png",
              ServiceText: (
                <>
                <p className="fs-14">
                    <b>Luxury Gift Hampers</b> 
                  </p>
                     
                </>
              ),
            },
            {
              ServiceImg: "../assests/images/sub-pages/color-matching.png",
              ServiceText: (
                <>
                    <p className="fs-14">
                    <b>Luxury Gift Hampers</b>
                  </p>
    
                </>
              ),
            },
          ],
        },
      ];
     
    return(
        <>
            <Helmet>
        <title>   Experiential Gifting</title>
        </Helmet>
        <div className="p-0 m-2">
        <Ctapage data={CTAContent} />
      <Container>
        <LeftContentRightImg data={SubpgesLeftContent[0]} />
      </Container>
      <NogapleftImg data={noGapContent[0]}/>
      <Container>
        <LeftContentRightImg data={SubpgesLeftContent[1]} />
      </Container>
      <NogapleftImg data={noGapContent[1]}/> 
      </div>
      <p className="text-center fs-32 w-75 d-block m-auto py-5">
        Let us help you craft unforgettable experiences for employees, clients, event attendees, and more. 
      </p>
        </>
    )
}

export default ExperientialGifitng;